<template>
    <div>
        <div style="height: 430px;background:#e6e9ee;">
            <div style="width: 1200px;margin: 0px auto;height: 100%;font-size: 16px;justify-content: space-between;"
                class="file falign">
                <div style="width:175px;border-right: 3px solid #fff;">
                    <div :class="[{ 'mindex': mindex == i }, { 'menu': mindex != i }]" @click="getInfo(i)"
                        style="height: 40px;padding-right: 30px;text-align: right;line-height:40px;cursor: pointer;"
                        v-for="(x, i) in menus">{{
                            x.name }}</div>
                </div>
                <div style="width: 345px;height: 280px;margin-top: 10px;margin-left: 10px;">
                    <div style="font-size: 40px;">{{ data.name }}</div>
                    <div style="margin-top: 30px;line-height: 28px;color: #555;">{{ data.desc }}</div>
                </div>
                <div style="border: 10px solid #fff;border-radius: 30px;">
                    <img :src="data.img">
                </div>
            </div>
        </div>

        <div style="padding:15px 0px;">
            <div style="width: 1200px;border:1px solid rgb(231 231 231);margin: 35px auto;position: relative;border-radius: 23px;"
                v-for="(x, i) in data.caseList" :key="i">
                <div style="position: absolute;left: -8px;top: -4px;height: 78px;width: 130px;background-size: 100% 100%;text-align: center;line-height: 55px;font-size: 18px;color: #fff;font-weight: bold;"
                    :style="{ backgroundImage: 'url(' + require('@/assets/hometo/bqbj@2x.png') + ')' }">
                    案例{{ setnum(i) }}
                </div>
                <div style="margin-left: 140px;margin-top:26px;display: flex;align-items: center;">
                    <div style="font-size: 28px;">{{ x.title }}</div>
                    <div style="margin-left: 10px; width: 90px;height: 30px;text-align: center;line-height: 30px;font-size: 14px;color: #fff; background-size: 100% 100%;"
                        :style="{ backgroundImage: 'url(' + require('@/assets/hometo/557@2x.png') + ')' }">
                        {{ x.badgeText }}
                    </div>
                </div>
                <div style="margin-top: 35px;margin-left: 80px;display: flex;align-items: center;">
                    <div style=" width: 200px;height: 180px;text-align: center;line-height: 160px;font-size: 20px;color: #fff; background-size: 100% 100%;font-weight: bold;"
                        :style="{ backgroundImage: 'url(' + require('@/assets/hometo/ywbj@2x.png') + ')' }">
                        <div style="margin-right: 10px;">业务背景</div>
                    </div>
                    <div style="font-size: 14px;width: 800px;margin-left: 50px;line-height: 25px;">
                        {{ x.bgContent }}
                    </div>
                </div>
                <div
                    style="position: relative;width: 1113px;height: 463px;margin: 0px auto;margin-top: 45px;z-index: 10;">
                    <img style="" src="../../assets/hometo/td1.png">
                    <div style="position: absolute;left: 0px;top: 0px;display: flex;justify-content: space-between;">
                        <div style="margin-left: 40px;">
                            <div
                                style="font-size: 16px;color: #fff;font-weight: bold;text-align: center;margin-left: 20px;margin-top: 10px;">
                                痛点</div>
                            <div v-for="(z, j) in x.painList" :key="j"
                                style="display: flex;align-items: center;margin-top: 50px;">
                                <div style="width: 45px;"><img src="../../assets/hometo/huaban-5987685150@2x.png"></div>
                                <div style="font-size: 14px;width: 300px;margin-left: 15px;">{{ z }}</div>
                            </div>
                        </div>
                        <div style="margin-left: 135px;">
                            <div
                                style="font-size: 16px;color: #fff;font-weight: bold;text-align: center;margin-left: 5px;width: 540px;margin-top: 10px;padding-bottom: 5px;">
                                WorkBuddy 方案</div>
                            <div v-for="(z, j) in x.solutionSteps" :key="j"
                                style="display: flex;align-items: center;margin-top: 45px;">
                                <div style="width: 45px;"><img src="../../assets/hometo/huaban-6666154900@2x.png"></div>
                                <div style="margin-left: 15px;">
                                    <div style="font-size: 16px;font-weight: bold;">{{ z.title }}</div>
                                    <div style="font-size: 14px;">{{ z.desc }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: relative;">
                    <div style="position: absolute;left: 0px;top: -58px;"><img style="width: 100%;"
                            src="../../assets/hometo/t64.png"></div>
                    <div style="height: 270px;position: relative;z-index: 10;">
                        <div style="text-align: center;font-size: 20px;padding-top: 50px;font-weight: bold;">最终效果</div>
                        <div
                            style="display: flex;align-items: center;justify-content: space-between;padding: 40px 180px">
                            <div v-for="(z, j) in x.effectList" :key="j"
                                style="text-align: center;width: 200px;height: 90px;background-size: 100% 100%;"
                                :style="{ backgroundImage: 'url(' + require('@/assets/hometo/jx5.png') + ')' }">
                                <div style="color: #f14e4e;font-weight: bold;font-size: 24px;margin-top: 10px;">{{
                                    z.value }}</div>
                                <div style="font-size: 16px;">{{ z.label }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            mindex: 0,
            menus: [],
            data: {},
            industryList: [
                {
                    "id": "manufacturing",
                    "name": "制造业",
                    "icon": "🏭",
                    "className": "ind-manufacturing",
                    img: require('@/assets/hometo/alxq1.png'),
                    "desc": "覆盖金属贸易、PCB电子、高分子材料、食品生产等细分领域，解决ERP数据孤岛、多基地运营、文档自动化等核心痛点",
                    "caseList": [
                        {
                            "customer": "XXX科技股份有限公司 · 运营团队",
                            "title": "高分子材料软管制造 · 多基地运营数据汇总与分析",
                            "badgeText": "200+产线",
                            "badgeStyle": "background:#E8F0FF;color:#0052D9;",
                            "bgContent": "专注高分子材料流体传输软管研发制造，拥有泰州、滁州、成都等多个生产基地，200+条产线，产品出口70+个国家。运营团队需汇总多基地生产日报、制作月度经营报告与SOP文档，此前完全依赖手工Excel+Word操作。",
                            "painList": [
                                "多基地Excel报表分散孤立，运营每天手工汇总耗时2-3小时，易出错且滞后",
                                "月度经营报告、SOP、周报等高频文档反复排版，格式不统一，管理层跨地域查阅效率低",
                                "数据分析门槛高，运营不懂SQL/VBA，趋势洞察依赖IT排期，响应慢难以及时支撑决策"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "数据接入",
                                    "desc": "多基地Excel/ERP报表一句话导入，自动合并去重、数据清洗"
                                },
                                {
                                    "num": 2,
                                    "title": "智能分析",
                                    "desc": "运营岗人员通过自然语言提问即可生成产量趋势、排名与异常预警，零门槛操作"
                                },
                                {
                                    "num": 3,
                                    "title": "文档生成",
                                    "desc": "经营报告/SOP/周报按企业模板一句话生成，格式统一零偏差"
                                },
                                {
                                    "num": 4,
                                    "title": "定时推送",
                                    "desc": "通过自动化任务，每天定时推送数据信息至管理层"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-70%",
                                    "label": "数据汇总耗时"
                                },
                                {
                                    "value": "1句话",
                                    "label": "生成日报/周报"
                                },
                                {
                                    "value": "0偏差",
                                    "label": "文档排版格式"
                                },
                                {
                                    "value": "统一",
                                    "label": "多基地数据看板"
                                }
                            ]
                        },
                        {
                            "customer": "江苏XXX电子股份有限公司 · 运营&销售",
                            "title": "PCB / 电子元件制造 · ERP数据自动报表与智能制造",
                            "badgeText": "鼎捷T100",
                            "badgeStyle": "background:#E8F0FF;color:#0052D9;",
                            "bgContent": "PCB/电子元件制造企业，希望WorkBuddy与钉钉集成，从鼎捷T100 ERP抓取业务数据，自动生成M16/H10/HS1等项目的报废面积、客退报废面积、总入库面积、总良率%与目标值报表，按月/周/日/累计维度展示趋势与明细，并要求历史数据本地存档、权限控制、失败重试与日志记录。",
                            "painList": [
                                "报表分发依赖邮件/钉钉群手动转发，无法实时查看与导出PDF",
                                "T100 ERP数据导出后人工汇总入Excel，月报/周报/日报口径不一致，易出错",
                                "历史数据散落各处，缺乏统一存档与审计追溯，复盘分析效率低"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "钉钉集成",
                                    "desc": "钉钉端触发或定时任务调用，支持消息推送与权限控制"
                                },
                                {
                                    "num": 2,
                                    "title": "ERP对接",
                                    "desc": "WorkBuddy直连鼎捷T100，按需读取业务数据"
                                },
                                {
                                    "num": 3,
                                    "title": "指标计算",
                                    "desc": "按口径自动计算良率、报废、入库等核心指标"
                                },
                                {
                                    "num": 4,
                                    "title": "报表交付",
                                    "desc": "Excel/PDF输出，定时刷新+本地存档+失败重试"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "100%",
                                    "label": "报表口径统一"
                                },
                                {
                                    "value": "本地存档",
                                    "label": "数据安全可追溯"
                                },
                                {
                                    "value": "全自动",
                                    "label": "失败重试+日志记录"
                                },
                                {
                                    "value": "多平台",
                                    "label": "钉钉生态集成"
                                }
                            ]
                        },
                        {
                            "customer": "某金属贸易公司 · 全员办公",
                            "title": "金属贸易 · 合同/报价单自动生成与智能审核",
                            "badgeText": "10人团队",
                            "badgeStyle": "background:#E8F0FF;color:#0052D9;",
                            "bgContent": "公司日常工作存在大量合同、报价单生成和审核工作，公司内部也有很多文档需要流转和整理，文书工作繁重，经常出错。",
                            "painList": [
                                "存在大量重复且低效的办公环节",
                                "人工编写、审核错误率高，需交叉复审",
                                "资料梳理、归档、查阅方面效率低下"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "合同生成",
                                    "desc": "根据客户名等信息自动生成定制化合同"
                                },
                                {
                                    "num": 2,
                                    "title": "方案编写",
                                    "desc": "根据客户需求定制产品方案，可根据公司文档沉淀进行方案自学习和更新"
                                },
                                {
                                    "num": 3,
                                    "title": "智能审核",
                                    "desc": "审核整个贸易流程的文书是否符合规范，有无错误、纰漏等"
                                },
                                {
                                    "num": 4,
                                    "title": "资料梳理",
                                    "desc": "整理公司资料，归档并总结，高效查阅"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+100%",
                                    "label": "合同编写自动化"
                                },
                                {
                                    "value": "-90%",
                                    "label": "错误率"
                                },
                                {
                                    "value": "自动",
                                    "label": "遵循企业规范"
                                }
                            ]
                        },
                        {
                            "customer": "XX科技有限公司 · 人事/行政/研发/品控/生产",
                            "title": "聚氨酯驱动轮制造 · 办公提效与跨部门智能协作",
                            "badgeText": "企微生态",
                            "badgeStyle": "background:#E8F0FF;color:#0052D9;",
                            "bgContent": "专注高分子材料研发及制品生产，主要生产聚氨酯驱动轮、承载轮、压配轮及其他聚氨酯实心轮胎。企业内部IT技术人员有限，人事、行政、研发、品控、生产等多部门日常办公使用企微沟通，每天20+企微在线文档/表格处理，信息分散在各部门，跨部门协作效率受限，知识沉淀困难。",
                            "painList": [
                                "在线文档表格填报频繁，每日需人工筛选、总结并回复，单批次处理耗时超40分钟，易遗漏重要信息",
                                "各部门工艺标准、质检规范、设备手册分散存储，员工查找效率低，知识复用率低",
                                "缺乏IT技术背景的员工无法高效完成数据分析、信息汇总等办公任务"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "企微文档对接",
                                    "desc": "通过企微API模式机器人+WorkBuddy企微连接器，对企微在线文档/表格增删改查"
                                },
                                {
                                    "num": 2,
                                    "title": "企业知识库",
                                    "desc": "借助WorkBuddy企业旗舰版知识库，统一维护工艺标准、质检规范等内部知识"
                                },
                                {
                                    "num": 3,
                                    "title": "全员办公助手",
                                    "desc": "利用办公套件+专家团+Skill组合能力，提供数据分析、信息总结等日常办公能力"
                                },
                                {
                                    "num": 4,
                                    "title": "跨部门协作",
                                    "desc": "打通人事、行政、研发、品控、生产五部门信息流转"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+80%",
                                    "label": "在线办公处理效率"
                                },
                                {
                                    "value": "+60%",
                                    "label": "知识查找效率"
                                },
                                {
                                    "value": "+50%",
                                    "label": "跨部门协作效率"
                                }
                            ]
                        },
                        {
                            "customer": "某食品生产公司 · 全员",
                            "title": "食品生产 · 生产计划与原材料采购智能排程",
                            "badgeText": "产品畅销海内外",
                            "badgeStyle": "background:#E8F0FF;color:#0052D9;",
                            "bgContent": "日常涉及安全生产、原材料采购计划、销售订单整理、产品推广文案和营销材料输出、阶段工作汇总和数据分析，存在大量耗时和重复性工作。",
                            "painList": [
                                "公司重心在生产部门，无有效人效管理手段，日常繁琐的数据整理工作消耗大量时间",
                                "生产计划存在阶段性调整，结合订单制定采购计划人工核算工作量大、易出错",
                                "往期沉淀数据利用率低，营销素材重复创作、创新不足"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "人效管理",
                                    "desc": "终端授权管理，积分用量分配制，用量看板API接入统一管理"
                                },
                                {
                                    "num": 2,
                                    "title": "计划+订单整理",
                                    "desc": "生产任务标准化，结合订单数据自动生成原材料采购计划"
                                },
                                {
                                    "num": 3,
                                    "title": "文案快速生成",
                                    "desc": "依托历史素材，生成适配不同客户群体的多风格营销内容"
                                },
                                {
                                    "num": 4,
                                    "title": "数据汇总分析",
                                    "desc": "自然语言驱动数据统计，自动生成结论与可视化图表"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+80%",
                                    "label": "办公提效"
                                },
                                {
                                    "value": "0基础",
                                    "label": "自然语言零门槛"
                                },
                                {
                                    "value": "统一",
                                    "label": "企业级管理"
                                },
                                {
                                    "value": "安全",
                                    "label": "沙箱+数据本地化"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "ecommerce",
                    "name": "电商/跨境电商",
                    "icon": "🛒",
                    "className": "ind-ecommerce",
                    img: require('@/assets/hometo/alxq2.png'),
                    "desc": "覆盖亚马逊跨境、淘宝生态、洗化电商、外贸进出口等场景，解决数据孤岛、客服效率、内容产出等核心痛点",
                    "caseList": [
                        {
                            "customer": "某电子商务有限公司 · 运营专员",
                            "title": "跨境电商 · 大盘监控与广告投流优化",
                            "badgeText": "亚马逊平台",
                            "badgeStyle": "background:#FFF3E0;color:#E65100;",
                            "bgContent": "经营多年的跨境电商商家，在亚马逊平台销售。此前决策主要依赖运营经验和个人直觉，缺乏数据支撑。",
                            "painList": [
                                "选品靠感觉，上架才发现市场已红海；产品生命周期阶段判断不清",
                                "不知定价多少利润和销量平衡最优",
                                "广告费消耗大，ACOS居高不下，无法区分低效关键词",
                                "多广告组ROI差异大，人工分析耗时"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "大盘监控",
                                    "desc": "自动采集行业趋势报告、监控竞品ASIN排名变动并定时推送"
                                },
                                {
                                    "num": 2,
                                    "title": "品类分析",
                                    "desc": "导出JS/H10 CSV数据，深度分析生成报告，提取竞品差评转化产品卖点"
                                },
                                {
                                    "num": 3,
                                    "title": "广告优化",
                                    "desc": "广告报表自动分层，给出调价、增删关键词明确方案"
                                },
                                {
                                    "num": 4,
                                    "title": "自动化任务",
                                    "desc": "每日自动推送前一日数据与优化方案"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-80%",
                                    "label": "数据处理与清洗时间"
                                },
                                {
                                    "value": "-80%",
                                    "label": "多维度分析对比时间"
                                },
                                {
                                    "value": "自动",
                                    "label": "定时推送优化方案"
                                }
                            ]
                        },
                        {
                            "customer": "某电子商务有限公司 · 全公司",
                            "title": "洗化电商 · 运营提效与智能客服",
                            "badgeText": "8人精干团队",
                            "badgeStyle": "background:#FFF3E0;color:#E65100;",
                            "bgContent": "专注于洗化类目（洗碗块等家居清洁产品）电商运营，仅8人精干团队，需承担从选品、运营、客服到营销的全链条工作，人效要求极高。",
                            "painList": [
                                "会员分层、复购、流失预警全靠Excel手动分析，决策滞后",
                                "淘宝、会员、客服三平台数据割裂，报表拼接耗时长",
                                "竞品价格评论人工盯守，客服回复人力消耗大",
                                "商品文案、评价回复全部人工撰写"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "数据智能接入",
                                    "desc": "打通淘宝、会员、客服多源数据，自动汇总分析"
                                },
                                {
                                    "num": 2,
                                    "title": "AI运营预测",
                                    "desc": "自动分层用户，复购流失精准预警"
                                },
                                {
                                    "num": 3,
                                    "title": "智能客服提效",
                                    "desc": "80%高频咨询自动应答，响应速度提升5倍"
                                },
                                {
                                    "num": 4,
                                    "title": "内容自动化",
                                    "desc": "一键生成详情、推广、评价文案"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+30%",
                                    "label": "整体运营效率"
                                },
                                {
                                    "value": "80%+",
                                    "label": "客服自动回复率"
                                },
                                {
                                    "value": "+70%",
                                    "label": "数据处理效率"
                                },
                                {
                                    "value": "+60%",
                                    "label": "内容产出效率"
                                },
                                {
                                    "value": "85%",
                                    "label": "流失预警准确率"
                                }
                            ]
                        },
                        {
                            "customer": "重庆某电子商务有限公司 · 运营经理",
                            "title": "电商全链路数据智能洞察 · 选品策略",
                            "badgeText": "淘宝生态ISV",
                            "badgeStyle": "background:#FFF3E0;color:#E65100;",
                            "bgContent": "自研电商业务管理系统，沉淀商家全链路交易、商品、售后、客服数据，存在数据量大但难以深度洞察问题。",
                            "painList": [
                                "海量SKU爆款归因困难，业务数据相互割裂",
                                "退货异常人工追溯，质量定位周期长",
                                "客服质量对复购的影响无法量化"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "数据驾驶舱",
                                    "desc": "WorkBuddy接入全链路数据，搭建统一决策看板"
                                },
                                {
                                    "num": 2,
                                    "title": "质量追溯",
                                    "desc": "自动关联销量、售后数据，精准定位质量问题"
                                },
                                {
                                    "num": 3,
                                    "title": "客服洞察",
                                    "desc": "解析聊天日志，量化服务与复购关联关系"
                                },
                                {
                                    "num": 4,
                                    "title": "选品策略",
                                    "desc": "提取爆款共性特征，输出科学市场切入方案"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "实时",
                                    "label": "数据洞察"
                                },
                                {
                                    "value": "全链路",
                                    "label": "孤岛打通"
                                },
                                {
                                    "value": "精准",
                                    "label": "退货归因"
                                },
                                {
                                    "value": "智能",
                                    "label": "选品策略"
                                }
                            ]
                        },
                        {
                            "customer": "某外贸公司 · 运营助理/销售经理",
                            "title": "外贸公司 · 数据管理与办公提效",
                            "badgeText": "20+员工",
                            "badgeStyle": "background:#FFF3E0;color:#E65100;",
                            "bgContent": "旗下20余名销售营销人员，日常处理商品图文、宣传文案、订单、商品浏览量统计工作。",
                            "painList": [
                                "人工数据分析速度慢，错失营销窗口",
                                "商品浏览数据人工统计费时",
                                "营销风格杂乱，图文批量处理成本高"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "ERP订单对接",
                                    "desc": "跨境工具同步每日订单数据自动汇总"
                                },
                                {
                                    "num": 2,
                                    "title": "营销文案生成",
                                    "desc": "统计商品流量数据，快速产出推广素材"
                                },
                                {
                                    "num": 3,
                                    "title": "快速覆盖推广",
                                    "desc": "批量处理商品图文，统一品牌视觉风格"
                                },
                                {
                                    "num": 4,
                                    "title": "商品商机转化",
                                    "desc": "依托数据报表调整销售策略"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+60%",
                                    "label": "数据处理速度"
                                },
                                {
                                    "value": "-50%",
                                    "label": "图片处理时间"
                                },
                                {
                                    "value": "+70%",
                                    "label": "商品转化分析"
                                },
                                {
                                    "value": "+30%",
                                    "label": "商品覆盖率"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "medical",
                    "name": "医疗医药/生物科技",
                    "icon": "⚕️",
                    "className": "ind-medical",
                    img: require('@/assets/hometo/alxq3.png'),
                    "desc": "覆盖医疗信息化ISV、生物医疗、生物科技研发、大健康平台等场景，解决合规要求、实验文档、文献检索等核心痛点",
                    "caseList": [
                        {
                            "customer": "某医疗信息化ISV · 132人研发团队",
                            "title": "医疗信息化ISV · Figma2Code与代码合规本地化",
                            "badgeText": "30万+医院终端",
                            "badgeStyle": "background:#E0F5EC;color:#00897B;",
                            "bgContent": "主营医疗设备、输血管理软件，服务30万医院终端，40%新开发、60%老系统迭代，行业数据合规要求极高。",
                            "painList": [
                                "Figma转代码单组件耗时2-3小时",
                                "老旧项目代码难理解，新人上手需2个月",
                                "境外AI工具无法满足医疗数据本地合规要求"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "Figma2Code",
                                    "desc": "设计稿一键生成生产代码，单组件耗时降至15分钟"
                                },
                                {
                                    "num": 2,
                                    "title": "代码质量保障",
                                    "desc": "全局读取项目代码，自动定位Bug、辅助重构老系统"
                                },
                                {
                                    "num": 3,
                                    "title": "代码自动生成",
                                    "desc": "代码补全、批量生成业务模块加速开发"
                                },
                                {
                                    "num": 4,
                                    "title": "安全合规",
                                    "desc": "国产本地化大模型，满足医疗行业数据监管要求"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "60%+",
                                    "label": "AI采纳率"
                                },
                                {
                                    "value": "-30%",
                                    "label": "交付周期"
                                },
                                {
                                    "value": "3周",
                                    "label": "新人上手（原2个月）"
                                },
                                {
                                    "value": "-50%",
                                    "label": "合规审查成本"
                                }
                            ]
                        },
                        {
                            "customer": "某生物科技有限公司 · 跨部门",
                            "title": "生物医疗公司 · 专项助手与自定义Skills",
                            "badgeText": "500员工",
                            "badgeStyle": "background:#E0F5EC;color:#00897B;",
                            "bgContent": "企业500名员工，财务、人力、研发存在大量表格数据，单表人工整理约60分钟，业务推进缓慢。",
                            "painList": [
                                "各类数据表人工整理耗时1小时/份",
                                "各部门数据逻辑不同，专业人员归纳成本高",
                                "模型消耗无监控，额外费用不可控",
                                "通用Skill精准度不足，需定制部门专属能力"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "简易安装",
                                    "desc": "一键部署，无需额外开发对比开源方案"
                                },
                                {
                                    "num": 2,
                                    "title": "自定义Skills管理",
                                    "desc": "搭建各部门专属自动化技能，跨部门提效"
                                },
                                {
                                    "num": 3,
                                    "title": "自动化流程",
                                    "desc": "定时执行报表、文档任务，避免人工遗忘"
                                },
                                {
                                    "num": 4,
                                    "title": "企业用量管理",
                                    "desc": "模型消耗明细可查，精准控制预算支出"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-90%",
                                    "label": "人力时间"
                                },
                                {
                                    "value": "低门槛",
                                    "label": "对话式交互"
                                },
                                {
                                    "value": "定制化",
                                    "label": "自定义Skills"
                                },
                                {
                                    "value": "可控",
                                    "label": "费用消耗可见"
                                }
                            ]
                        },
                        {
                            "customer": "深圳某生物科技有限公司 · 研究员/项目专员",
                            "title": "生物科技研发 · 实验报告AI生成与文献语义检索",
                            "badgeText": "研发驱动",
                            "badgeStyle": "background:#E0F5EC;color:#00897B;",
                            "bgContent": "核心工作为实验设计、检测报告、专利、申报材料撰写，同时需要大量中英文文献查阅。",
                            "painList": [
                                "实验、专利、申报材料纯手写效率极低",
                                "海量文献逐篇阅读，前沿追踪滞后",
                                "产品、申报方案反复修改调整"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "实验报告AI生成",
                                    "desc": "AI起草专业文档，自动校核行业术语"
                                },
                                {
                                    "num": 2,
                                    "title": "文献提炼",
                                    "desc": "语义检索，一键输出文献核心结论"
                                },
                                {
                                    "num": 3,
                                    "title": "高频起草",
                                    "desc": "方案模板一键套用，快速标准化输出"
                                },
                                {
                                    "num": 4,
                                    "title": "全链路减负",
                                    "desc": "研发类重复文档交由AI处理"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "AI辅助",
                                    "label": "实验报告生成"
                                },
                                {
                                    "value": "秒出",
                                    "label": "文献语义检索"
                                },
                                {
                                    "value": "一键",
                                    "label": "模板套用"
                                }
                            ]
                        },
                        {
                            "customer": "泛互联网+大健康业务公司 · 技术总监及研发",
                            "title": "大健康平台 · 研发提效与模型降本",
                            "badgeText": "200+语言支持",
                            "badgeStyle": "background:#E0F5EC;color:#00897B;",
                            "bgContent": "为健康厂商提供CRM、云平台服务，同步搭建漫剧、语音识别AIGC产品，多项目并行研发压力大。",
                            "painList": [
                                "多项目并行易延期，研发负载高",
                                "Bug检测流程漫长",
                                "开发代码规范不统一，技术债堆积",
                                "海外大模型使用成本高昂"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "规范统一",
                                    "desc": "CodeBuddy统一团队代码编写标准"
                                },
                                {
                                    "num": 2,
                                    "title": "计划+工具生成",
                                    "desc": "基于国产大模型生成开发方案、自动化脚本"
                                },
                                {
                                    "num": 3,
                                    "title": "多语言支持",
                                    "desc": "200+开发语言，兼容IDE/CLI/插件形态"
                                },
                                {
                                    "num": 4,
                                    "title": "反馈自动化调优",
                                    "desc": "持续根据项目反馈优化代码检查规则"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "0.5人力",
                                    "label": "1账号研发提效"
                                },
                                {
                                    "value": "-80%",
                                    "label": "模型替换降本"
                                },
                                {
                                    "value": "稳定",
                                    "label": "开箱即用"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "finance",
                    "name": "金融行业",
                    "icon": "💰",
                    "className": "ind-finance",
                    img: require('@/assets/hometo/alxq4.png'),
                    "desc": "覆盖银行/证券、投资管理、金融信息服务等场景，解决报表依赖IT、审批低效、合规审查等核心痛点",
                    "caseList": [
                        {
                            "customer": "某区域性金融机构 · 12用户",
                            "title": "区域性银行/证券 · 报表自动生成与风控看板",
                            "badgeText": "合规本地化",
                            "badgeStyle": "background:#FCE4EC;color:#AD1457;",
                            "bgContent": "IT团队人力紧张，业务部门频繁索要销售、风控、分支机构各类报表，70%工时消耗在取数出表。",
                            "painList": [
                                "业务等待报表1-2小时，影响经营决策",
                                "IT沦为取数人员，核心开发工作停滞",
                                "历史报表分散，每次需要重新制作"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "报表自动生成",
                                    "desc": "多系统数据接入，模板化输出，出表时长1-2h缩至5min"
                                },
                                {
                                    "num": 2,
                                    "title": "即时数据查询",
                                    "desc": "业务人员自然语言查数，秒出图表结果"
                                },
                                {
                                    "num": 3,
                                    "title": "历史报表复用",
                                    "desc": "报表存入知识库，同类需求一键复用模板"
                                },
                                {
                                    "num": 4,
                                    "title": "风控指标看板",
                                    "desc": "聚合多源风控数据，异常自动告警"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-70%",
                                    "label": "报表等待时间"
                                },
                                {
                                    "value": "+70%",
                                    "label": "报表复用率"
                                },
                                {
                                    "value": "5min",
                                    "label": "报表生成（原1-2h）"
                                },
                                {
                                    "value": "实时",
                                    "label": "风控智能告警"
                                }
                            ]
                        },
                        {
                            "customer": "某投资有限公司 · 行政人员",
                            "title": "投资管理集团 · 企业数字化与AI办公转型",
                            "badgeText": "17家子公司",
                            "badgeStyle": "background:#FCE4EC;color:#AD1457;",
                            "bgContent": "对外投资17家子公司，覆盖产业园、供应链、供热、医药商贸多业态，线下审批、纸质单据多，监管合规文档量大。",
                            "painList": [
                                "跨子公司线下审批协同效率极低",
                                "投资分析依赖人工经验，缺少AI辅助研判",
                                "国资监管文档、上报材料重复撰写"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "数字办公上线",
                                    "desc": "总部投资部先落地尽调、合同、纪要自动化"
                                },
                                {
                                    "num": 2,
                                    "title": "AI智能协同",
                                    "desc": "自动生成尽调、合同、政策解读文档"
                                },
                                {
                                    "num": 3,
                                    "title": "AI决策赋能",
                                    "desc": "自动汇总子公司经营、行业政策辅助投资判断"
                                },
                                {
                                    "num": 4,
                                    "title": "子公司全面推广",
                                    "desc": "全集团行政、财务、供应链统一使用"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+60%",
                                    "label": "协同办公效率"
                                },
                                {
                                    "value": "-60%",
                                    "label": "审批流转周期"
                                },
                                {
                                    "value": "17家",
                                    "label": "子公司统一管理"
                                },
                                {
                                    "value": "自动",
                                    "label": "合规审查"
                                }
                            ]
                        },
                        {
                            "customer": "北京某投资管理有限公司 · 投资经理",
                            "title": "投资管理公司 · 资产投资决策提效",
                            "badgeText": "IMA→乐享迁移",
                            "badgeStyle": "background:#FCE4EC;color:#AD1457;",
                            "bgContent": "投资经验仅存储在员工个人知识库，团队无法共享，海量项目人工尽调研判成本高。",
                            "painList": [
                                "资深投资经验个人独占，团队无法复用",
                                "海量项目人工财务、行业对标耗时",
                                "新项目缺少历史案例做风险校验"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "经验迁移",
                                    "desc": "个人知识库资产迁移至企业共享知识库"
                                },
                                {
                                    "num": 2,
                                    "title": "智能投顾",
                                    "desc": "秒级匹配历史同类投资案例"
                                },
                                {
                                    "num": 3,
                                    "title": "风险测算",
                                    "desc": "通过项目特征比对智能测算风险，规避决策误区"
                                },
                                {
                                    "num": 4,
                                    "title": "团队复用",
                                    "desc": "破除经验独享壁垒，团队成员均可复用资深积淀"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "秒级",
                                    "label": "案例匹配"
                                },
                                {
                                    "value": "智能",
                                    "label": "风险测算"
                                },
                                {
                                    "value": "全员",
                                    "label": "经验复用"
                                },
                                {
                                    "value": "提升",
                                    "label": "投研胜率"
                                }
                            ]
                        },
                        {
                            "customer": "某金融信息服务有限公司 · 办公人员",
                            "title": "金融信息服务公司 · 风险处置提效",
                            "badgeText": "OCR+数据分析",
                            "badgeStyle": "background:#FCE4EC;color:#AD1457;",
                            "bgContent": "业务包含诉讼材料、法院公告、出借兑付核算、监管与客户沟通文件，纸质/扫描文件海量。",
                            "painList": [
                                "纸质文件人工翻阅查找关键信息效率低",
                                "多表兑付核算人工录入易出错",
                                "对外回函、会议记录无统一管理，回复口径混乱"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "文件智能管理",
                                    "desc": "OCR批量解析文件，自动生成案件台账"
                                },
                                {
                                    "num": 2,
                                    "title": "数据精准核算",
                                    "desc": "多表自动汇总，生成兑付可视化报表"
                                },
                                {
                                    "num": 3,
                                    "title": "沟通标准化",
                                    "desc": "会议实时生成结构化纪要，标准化对外文书"
                                },
                                {
                                    "num": 4,
                                    "title": "合规存档",
                                    "desc": "全流程操作留痕，满足监管存档要求"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "5x+",
                                    "label": "文档处理效率"
                                },
                                {
                                    "value": "零差错",
                                    "label": "结构化核算"
                                },
                                {
                                    "value": "全存档",
                                    "label": "满足监管要求"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "construction",
                    "name": "建筑装饰/科技服务",
                    "icon": "🏗️",
                    "className": "ind-construction",
                    img: require('@/assets/hometo/alxq5.png'),
                    "desc": "覆盖装饰工程、装饰设计、科技服务等场景，解决标书撰写、合同审核、客服标准化等核心痛点",
                    "caseList": [
                        {
                            "customer": "某建筑装饰工程有限公司 · 投标/销售/客服",
                            "title": "装饰工程 · 标书报价与合同全流程自动化",
                            "badgeText": "合同30min→3min",
                            "badgeStyle": "background:#FFE7DC;color:#C2410C;",
                            "bgContent": "室内外幕墙、园林装饰一站式工程，投标、合同、营销文案、咨询文档工作量大。",
                            "painList": [
                                "标书报价手工制作易出错，投标响应慢",
                                "项目方案行业数据人工整合繁琐",
                                "营销文案合规人工排查有遗漏",
                                "合同审核依赖法务排期长"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "标书与报价单自动生成",
                                    "desc": "历史模板自动填充工程量与单价"
                                },
                                {
                                    "num": 2,
                                    "title": "方案撰写与数据抓取",
                                    "desc": "自动抓取行业政策、案例支撑项目方案"
                                },
                                {
                                    "num": 3,
                                    "title": "营销文案合规审核",
                                    "desc": "自动识别违规敏感词并给出修改方案"
                                },
                                {
                                    "num": 4,
                                    "title": "合同与客服自动化",
                                    "desc": "合同自动校验，客服统一标准话术库"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "30min→3min",
                                    "label": "合同生成耗时"
                                },
                                {
                                    "value": "+70%",
                                    "label": "投标响应速度"
                                },
                                {
                                    "value": "0敏感词",
                                    "label": "营销合规审核"
                                },
                                {
                                    "value": "+60%",
                                    "label": "客服效率"
                                }
                            ]
                        },
                        {
                            "customer": "某装饰设计研究院 · 设计师/项目负责人",
                            "title": "装饰设计院 · 方案书智能撰写与项目库沉淀",
                            "badgeText": "方案1天→2h",
                            "badgeStyle": "background:#FFE7DC;color:#C2410C;",
                            "bgContent": "商业、软装室内设计，提案重复劳动多，项目资料分散难查找。",
                            "painList": [
                                "方案70%内容可复用却每次从零撰写",
                                "行业案例、政策人工搜集更新慢",
                                "缺少竞品对标，方案优势不直观",
                                "新人接手项目资料查找成本高"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "方案智能撰写",
                                    "desc": "复用历史模板快速生成差异化方案"
                                },
                                {
                                    "num": 2,
                                    "title": "多源数据抓取",
                                    "desc": "自动汇总行业政策案例并分类归档"
                                },
                                {
                                    "num": 3,
                                    "title": "竞品方案库",
                                    "desc": "自动量化项目差异化竞争亮点"
                                },
                                {
                                    "num": 4,
                                    "title": "项目知识沉淀",
                                    "desc": "全部项目方案存入知识库，新人快速上手"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "1天→2h",
                                    "label": "方案产出"
                                },
                                {
                                    "value": "100%",
                                    "label": "数据抓取覆盖"
                                },
                                {
                                    "value": "+60%",
                                    "label": "方案复用率"
                                },
                                {
                                    "value": "-50%",
                                    "label": "新人上手周期"
                                }
                            ]
                        },
                        {
                            "customer": "某科技服务有限公司 · 法务/客服/销售",
                            "title": "科技服务公司 · 合同审核与客服标准化",
                            "badgeText": "合同-80%耗时",
                            "badgeStyle": "background:#FFE7DC;color:#C2410C;",
                            "bgContent": "提供IT咨询、运维技术服务，合同量大，客服咨询无统一标准。",
                            "painList": [
                                "合同人工审查耗时长，风险条款易遗漏",
                                "客服回复口径杂乱，人力消耗大",
                                "业务知识存在员工个人手里，新人培训慢",
                                "SLA、隐私合规条款人工审核易忽略"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "合同智能审核",
                                    "desc": "自动提取关键条款、识别合规风险"
                                },
                                {
                                    "num": 2,
                                    "title": "标准话术库",
                                    "desc": "高频咨询自动匹配统一标准答案"
                                },
                                {
                                    "num": 3,
                                    "title": "合规前置审查",
                                    "desc": "自动扫描隐私、违约等高风险条款"
                                },
                                {
                                    "num": 4,
                                    "title": "知识库沉淀",
                                    "desc": "合同、客服案例统一归档复用"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-80%",
                                    "label": "合同审核耗时"
                                },
                                {
                                    "value": "+60%",
                                    "label": "客服效率"
                                },
                                {
                                    "value": "-50%",
                                    "label": "培训周期"
                                },
                                {
                                    "value": "0遗漏",
                                    "label": "关键合规条款"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "media",
                    "name": "媒体/广告/营销",
                    "icon": "📢",
                    "className": "ind-media",
                    img: require('@/assets/hometo/alxq6.png'),
                    "desc": "覆盖MCN、AI数字人、文化传媒、活动策划等场景，解决内容产能、创意枯竭、外包成本等核心痛点",
                    "caseList": [
                        {
                            "customer": "某MCN公司 · 运营团队",
                            "title": "MCN公司 · 小红书运营与营销提效",
                            "badgeText": "200+签约网红",
                            "badgeStyle": "background:#FFEBEE;color:#C62828;",
                            "bgContent": "200+达人矩阵，每日图文短视频200+，热点挖掘、文案创作占用大量人力。",
                            "painList": [
                                "优质内容人工创作耗时久",
                                "竞品、热点人工搜集效率低",
                                "内容同质化，创意不足"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "发现机会",
                                    "desc": "自动抓取赛道热点、爆款内容数据"
                                },
                                {
                                    "num": 2,
                                    "title": "文案撰写",
                                    "desc": "小红书口语化笔记一键生成，自带互动话术"
                                },
                                {
                                    "num": 3,
                                    "title": "推广营销",
                                    "desc": "封面、评论区配套文案批量产出"
                                },
                                {
                                    "num": 4,
                                    "title": "数据监控",
                                    "desc": "自动统计笔记互动数据用于复盘"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+100%",
                                    "label": "发文数量"
                                },
                                {
                                    "value": "-80%",
                                    "label": "创作耗时"
                                },
                                {
                                    "value": "多元",
                                    "label": "内容创意丰富"
                                },
                                {
                                    "value": "多平台",
                                    "label": "文案风格适配"
                                }
                            ]
                        },
                        {
                            "customer": "深圳某科技有限公司 · 运营团队",
                            "title": "AI数字人/短视频营销 · 直播脚本与招商文案批量生成",
                            "badgeText": "产能10x",
                            "badgeStyle": "background:#FFEBEE;color:#C62828;",
                            "bgContent": "主营数字人短视频、直播带货，市场团队每日招商、直播文案产能不足。",
                            "painList": [
                                "人工日产脚本仅5条，产出低下",
                                "客户案例无统一资料库，提案重复撰写",
                                "会议、项目文档难以沉淀复用"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "需求梳理",
                                    "desc": "统一沉淀高频内容需求模板"
                                },
                                {
                                    "num": 2,
                                    "title": "批量生成",
                                    "desc": "批量输出直播脚本、招商提案"
                                },
                                {
                                    "num": 3,
                                    "title": "方案归档",
                                    "desc": "客户案例存入企业专属知识库"
                                },
                                {
                                    "num": 4,
                                    "title": "智能检索复用",
                                    "desc": "快速匹配行业案例生成定制提案"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "10x",
                                    "label": "内容产能提升"
                                },
                                {
                                    "value": "50+条",
                                    "label": "日产（原5条）"
                                },
                                {
                                    "value": "-60%",
                                    "label": "成本压缩"
                                },
                                {
                                    "value": "1个",
                                    "label": "企业专属资料库"
                                }
                            ]
                        },
                        {
                            "customer": "徐州某咨询有限公司 · 漫剧生产员工",
                            "title": "文化传媒企业 · 漫剧创制全流程（Seedance 2.0）",
                            "badgeText": "单周产能+300%",
                            "badgeStyle": "background:#FFEBEE;color:#C62828;",
                            "bgContent": "动态漫IP制作，依托Seedance生成视频，前期脚本、分镜制作周期长、返工多。",
                            "painList": [
                                "脚本-分镜-成片多环节反复修改",
                                "平台流量下滑，外包成本压力大",
                                "分镜描述不准，AI成片反复试错"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "AI编导脚本生成",
                                    "desc": "输入人设梗概自动生成分场对白剧本"
                                },
                                {
                                    "num": 2,
                                    "title": "标准化分镜拆分",
                                    "desc": "输出适配Seedance的镜头表格"
                                },
                                {
                                    "num": 3,
                                    "title": "分镜提示词优化",
                                    "desc": "优化生成指令，提高一次出片成功率"
                                },
                                {
                                    "num": 4,
                                    "title": "自有IP知识库复用",
                                    "desc": "角色、画风模板沉淀复用"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+300%",
                                    "label": "单周产能提升"
                                },
                                {
                                    "value": "-60%",
                                    "label": "外包成本降低"
                                },
                                {
                                    "value": "分钟级",
                                    "label": "剧本→分镜耗时"
                                },
                                {
                                    "value": "精准",
                                    "label": "一键对接Seedance"
                                }
                            ]
                        },
                        {
                            "customer": "某传媒有限公司 · 运营/项目经理/品牌策划",
                            "title": "文化活动传媒 · 创意内容流水线与活动策划提效",
                            "badgeText": "内容产出4倍+",
                            "badgeStyle": "background:#FFEBEE;color:#C62828;",
                            "bgContent": "承接文旅、政企品牌活动，策划、短视频、结案文档写作量大。",
                            "painList": [
                                "策划、推广文案创作消耗核心创意时间",
                                "结案、报价文档重复编写",
                                "多项目并行文书协同卡顿"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "AI出稿",
                                    "desc": "活动方案、公众号推文秒级生成"
                                },
                                {
                                    "num": 2,
                                    "title": "提案&结案",
                                    "desc": "客户提案、结案报告一键生成"
                                },
                                {
                                    "num": 3,
                                    "title": "数据汇总",
                                    "desc": "活动曝光、转化数据自动汇总"
                                },
                                {
                                    "num": 4,
                                    "title": "聚焦创意",
                                    "desc": "团队从文案劳作转向客户创意对接"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "4倍+",
                                    "label": "内容产出提升"
                                },
                                {
                                    "value": "一键",
                                    "label": "提案结案"
                                },
                                {
                                    "value": "自动",
                                    "label": "数据汇总"
                                },
                                {
                                    "value": "聚焦",
                                    "label": "创意与增长"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "logistics",
                    "name": "物流/供应链",
                    "icon": "📦",
                    "className": "ind-logistics",
                    img: require('@/assets/hometo/alxq7.png'),
                    "desc": "覆盖国际物流、物流供应链、物流企业运维等场景，解决客服效率、单据OCR、开发提效等核心痛点",
                    "caseList": [
                        {
                            "customer": "某国际物流运输公司 · 50+客服人员",
                            "title": "国际物流运输 · 企微客服RAG与多模态数据处理",
                            "badgeText": "1000+客户",
                            "badgeStyle": "background:#EDE7F6;color:#4527A0;",
                            "bgContent": "企业微信承接客户咨询，每日消息5000+，客服需要处理图片、PDF单据，多系统切换操作繁琐。",
                            "painList": [
                                "图文单据人工提取信息，单次咨询耗时10分钟以上",
                                "单人每日咨询处理上限仅100条",
                                "客服话术不统一，人员流动培训成本高"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "对接企微Skill",
                                    "desc": "企微消息自动拉取、智能回复推送"
                                },
                                {
                                    "num": 2,
                                    "title": "多模态数据处理",
                                    "desc": "图文语音自动提取结构化业务信息"
                                },
                                {
                                    "num": 3,
                                    "title": "自建RAG知识库",
                                    "desc": "沉淀统一客服标准话术，快速应答客户"
                                },
                                {
                                    "num": 4,
                                    "title": "远程遥控",
                                    "desc": "小程序移动端处理紧急客户咨询"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "x2倍",
                                    "label": "客服问题回复量"
                                },
                                {
                                    "value": "-50%",
                                    "label": "单问题处理时间"
                                },
                                {
                                    "value": "-20%",
                                    "label": "客服人力成本"
                                },
                                {
                                    "value": "+50%",
                                    "label": "问题回复效率"
                                }
                            ]
                        },
                        {
                            "customer": "西安某物流供应链有限公司 · 行政人员",
                            "title": "物流供应链 · 报关单OCR识别与票务自动化",
                            "badgeText": "服务三星",
                            "badgeStyle": "background:#EDE7F6;color:#4527A0;",
                            "bgContent": "服务三星大型客户，报关、物流单据量大，自研Agent成本周期过长，采用WorkBuddy+OCR实现单据自动化。",
                            "painList": [
                                "报关、物流单据人工逐条录入耗时易错",
                                "多业务系统数据不通，重复上传核对",
                                "人力成本随业务扩张线性上涨"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "OCR智能识别",
                                    "desc": "自动提取报关单、订单关键字段信息"
                                },
                                {
                                    "num": 2,
                                    "title": "自动化上传",
                                    "desc": "识别数据自动回填业务系统，无需人工"
                                },
                                {
                                    "num": 3,
                                    "title": "团队协作",
                                    "desc": "进出口流程线上协同，SaaS落地快于自研"
                                },
                                {
                                    "num": 4,
                                    "title": "安全合规",
                                    "desc": "满足甲方数据安全，西安试点全国复制"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-90%",
                                    "label": "人工录入耗时"
                                },
                                {
                                    "value": "+10x",
                                    "label": "单日处理量"
                                },
                                {
                                    "value": "+300%",
                                    "label": "业务吞吐量"
                                },
                                {
                                    "value": "全集团",
                                    "label": "沪/厦/深推广"
                                }
                            ]
                        },
                        {
                            "customer": "某国际物流企业分公司 · 开发/运维",
                            "title": "国际物流企业分公司 · 运维开发提效",
                            "badgeText": "26人研发",
                            "badgeStyle": "background:#EDE7F6;color:#4527A0;",
                            "bgContent": "26人研发团队，维护集团ERP内部系统，需求变更频繁，无GPU私有化部署成本高。",
                            "painList": [
                                "业务需求频繁迭代，定制开发周期长",
                                "运维监控看板开发工作量大",
                                "私有化无GPU，自研AI开发工具成本高"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "需求沉淀",
                                    "desc": "读取现有代码库输出需求原型方案"
                                },
                                {
                                    "num": 2,
                                    "title": "AIcoding全流程",
                                    "desc": "大模型辅助编码、单元测试、一键发布"
                                },
                                {
                                    "num": 3,
                                    "title": "运维提效",
                                    "desc": "自动搭建实时运维监控看板"
                                },
                                {
                                    "num": 4,
                                    "title": "团队统一建设",
                                    "desc": "统一研发账号、沉淀团队技能知识库"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "0.5人力",
                                    "label": "1账号研发提效"
                                },
                                {
                                    "value": "-50%",
                                    "label": "开发周期"
                                },
                                {
                                    "value": "-70%",
                                    "label": "AI coding降本"
                                },
                                {
                                    "value": "专享版",
                                    "label": "兼顾安全"
                                }
                            ]
                        },
                        {
                            "customer": "某欧洲跨国技术公司中国子公司 · 售后服务部",
                            "title": "高端测量仪器外企 · 单证智能处理与多语言",
                            "badgeText": "中/英/日三语",
                            "badgeStyle": "background:#EDE7F6;color:#4527A0;",
                            "bgContent": "主营光学测量仪器销售售后，对接亚洲区域业务，外文技术文档、报关、投标文件多语种处理压力大。",
                            "painList": [
                                "欧美文档翻译周期长，行业术语不统一",
                                "投标报价手工制作1-2天",
                                "HS编码、报关材料人工整理合规风险高"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "售后知识问答",
                                    "desc": "IM对接故障库，新人上手3个月缩至1个月"
                                },
                                {
                                    "num": 2,
                                    "title": "多语言文档自动化",
                                    "desc": "一键生成中英日客户邮件、技术文档"
                                },
                                {
                                    "num": 3,
                                    "title": "销售投标助手",
                                    "desc": "输入客户需求自动生成竞品对标方案"
                                },
                                {
                                    "num": 4,
                                    "title": "单证智能处理",
                                    "desc": "发票合同自动提取字段填充报关模板"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+50%",
                                    "label": "售后问答效率"
                                },
                                {
                                    "value": "分钟级",
                                    "label": "报价单/售后报告"
                                },
                                {
                                    "value": "1个月",
                                    "label": "新人上手（原3个月）"
                                },
                                {
                                    "value": "三语",
                                    "label": "中/英/日翻译"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "automotive",
                    "name": "汽车",
                    "icon": "🚗",
                    "className": "ind-automotive",
                    img: require('@/assets/hometo/alxq8.png'),
                    "desc": "覆盖汽车软件开发商、汽车艺术设计、车载系统等场景，解决研发效率、合规交付、库存管理等核心痛点",
                    "caseList": [
                        {
                            "customer": "某汽车软件开发商 · 研发团队",
                            "title": "汽车软件开发商 · 智能编程与安全交付",
                            "badgeText": "50+开发者",
                            "badgeStyle": "background:#ECEFF1;color:#37474F;",
                            "bgContent": "开发智能座舱、哨兵影像、车载功耗监控嵌入式软件，车规安全标准严苛。",
                            "painList": [
                                "图像算法低延迟调优难度大",
                                "车载隐私、功能安全合规约束多",
                                "多ECU联动逻辑复杂，调试周期长"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "零缺陷安全防线",
                                    "desc": "开发阶段主动扫描漏洞，减少上线修复"
                                },
                                {
                                    "num": 2,
                                    "title": "软硬协同性能",
                                    "desc": "嵌入式代码自动优化延迟、功耗表现"
                                },
                                {
                                    "num": 3,
                                    "title": "研发效能提升",
                                    "desc": "复用成熟代码资产减少重复开发"
                                },
                                {
                                    "num": 4,
                                    "title": "智能化安全领跑",
                                    "desc": "符合车规标准，快速完成量产交付"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-40%+",
                                    "label": "研发效率缩短"
                                },
                                {
                                    "value": "-50%+",
                                    "label": "缺陷下降"
                                },
                                {
                                    "value": "-30%+",
                                    "label": "成本减少"
                                },
                                {
                                    "value": "合规",
                                    "label": "快速量产后满足规范"
                                }
                            ]
                        },
                        {
                            "customer": "某汽车艺术设计公司 · 运营人员",
                            "title": "汽车艺术设计公司 · 报表录入与库存盘点",
                            "badgeText": "Notion集成",
                            "badgeStyle": "background:#ECEFF1;color:#37474F;",
                            "bgContent": "传统汽车内外饰设计企业，信息化薄弱，报表、设计文件、库存全部手工管理。",
                            "painList": [
                                "手工填报报表，无自动可视化图表",
                                "Figma设计信息人工拆解耗时久，迭代返工多",
                                "库存手工登记，账实不符"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "报表录入",
                                    "desc": "打通Notion自动分析流水线数据"
                                },
                                {
                                    "num": 2,
                                    "title": "设计方案解析",
                                    "desc": "自动提取Figma参数、输出设计规范文档"
                                },
                                {
                                    "num": 3,
                                    "title": "库存盘点",
                                    "desc": "搭建库存管理Skill，订单物料一体化管控"
                                },
                                {
                                    "num": 4,
                                    "title": "数据可视化",
                                    "desc": "自动生成对比、趋势图表"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-65%",
                                    "label": "人工填报工时"
                                },
                                {
                                    "value": "-80%",
                                    "label": "出错率"
                                },
                                {
                                    "value": "-90%",
                                    "label": "Figma提取工时"
                                },
                                {
                                    "value": "+80%",
                                    "label": "盘点效率"
                                }
                            ]
                        },
                        {
                            "customer": "深圳市某科技股份有限公司 · 研发/测试",
                            "title": "深圳汽车软件系统 · 车载系统深度开发",
                            "badgeText": "高标交付",
                            "badgeStyle": "background:#ECEFF1;color:#37474F;",
                            "bgContent": "车载安防、全景影像、能耗管控系统研发，行业开发规范严苛。",
                            "painList": [
                                "车载系统复杂度高，迭代周期长",
                                "人工无法全覆盖代码安全漏洞",
                                "车规合规落地整改工作量大"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "智能编码",
                                    "desc": "适配车载复杂业务加速代码开发"
                                },
                                {
                                    "num": 2,
                                    "title": "风险排查",
                                    "desc": "AI全域扫描代码潜在漏洞"
                                },
                                {
                                    "num": 3,
                                    "title": "合规适配",
                                    "desc": "代码自动贴合车载行业规范"
                                },
                                {
                                    "num": 4,
                                    "title": "高标交付",
                                    "desc": "降低项目验收整改成本"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "缩短",
                                    "label": "开发周期"
                                },
                                {
                                    "value": "AI",
                                    "label": "漏洞排查"
                                },
                                {
                                    "value": "严苛",
                                    "label": "合规车载规范"
                                },
                                {
                                    "value": "高标",
                                    "label": "项目交付"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "education",
                    "name": "教育/培训",
                    "icon": "📚",
                    "className": "ind-education",
                    img: require('@/assets/hometo/alxq9.png'),
                    "desc": "覆盖高校科研、智能化教育、教培综合服务等场景，解决政策采集、文档分析、合同审核等核心痛点",
                    "caseList": [
                        {
                            "customer": "北京XX大学 · 信息化处/网络中心",
                            "title": "高校 · 政策资讯智能采集与多源监控",
                            "badgeText": "0遗漏",
                            "badgeStyle": "background:#E8F5E9;color:#2E7D32;",
                            "bgContent": "需要持续抓取教育部、科技部、财政、招标平台通知，人工巡检整理效率极低。",
                            "painList": [
                                "政策原文冗长，人工筛选摘要耗时",
                                "多官网人工巡查易错过申报窗口期",
                                "手动分发给各学院工作量巨大"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "多源接入",
                                    "desc": "统一对接科教、财政、招投标官方站点"
                                },
                                {
                                    "num": 2,
                                    "title": "创建Skill",
                                    "desc": "自动过滤关键词、生成政策摘要"
                                },
                                {
                                    "num": 3,
                                    "title": "定时任务",
                                    "desc": "每日自动抓取、分类生成简报"
                                },
                                {
                                    "num": 4,
                                    "title": "企微推送",
                                    "desc": "按院系定向推送，支持归档检索"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "-90%",
                                    "label": "人工检索时间"
                                },
                                {
                                    "value": "0遗漏",
                                    "label": "关键政策不再错过"
                                },
                                {
                                    "value": "全覆盖",
                                    "label": "教育/科技/财政/招采"
                                },
                                {
                                    "value": "定向",
                                    "label": "按学院推送"
                                }
                            ]
                        },
                        {
                            "customer": "XXX教育科技有限公司 · 产品研发部",
                            "title": "智能化教育公司 · 理论体系构建与领导驾驶舱",
                            "badgeText": "PPT 2H→15min",
                            "badgeStyle": "background:#E8F5E9;color:#2E7D32;",
                            "bgContent": "专注家校关系、学生成长研究，海量教育文献、运营数据需要整理汇报。",
                            "painList": [
                                "人工单日仅能处理少量研究文献",
                                "各教育局、科研网站数据人工采集慢",
                                "缺少自动数据可视化分析工具"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "自动化数据采集",
                                    "desc": "每日定点自动抓取行业科研资料"
                                },
                                {
                                    "num": 2,
                                    "title": "辅助研究分析",
                                    "desc": "AI自动总结科研文档，人工仅核验"
                                },
                                {
                                    "num": 3,
                                    "title": "高效PPT生成",
                                    "desc": "汇报PPT2小时缩短至15分钟"
                                },
                                {
                                    "num": 4,
                                    "title": "领导驾驶舱",
                                    "desc": "自动生成交互式经营看板辅助决策"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "120min/天",
                                    "label": "自动化采集日节省"
                                },
                                {
                                    "value": "↑500%",
                                    "label": "日文档处理效率"
                                },
                                {
                                    "value": "2H→15min",
                                    "label": "PPT制作时间"
                                },
                                {
                                    "value": "可视化",
                                    "label": "领导驾驶舱"
                                }
                            ]
                        },
                        {
                            "customer": "某综合教育与政企服务集团 · 20用户",
                            "title": "教育/政企综合服务集团 · 合同审核与教培方案",
                            "badgeText": "合同30min→5min",
                            "badgeStyle": "background:#E8F5E9;color:#2E7D32;",
                            "bgContent": "业务覆盖招投标、法务合同、教培方案、Excel数据处理，人工瓶颈突出。",
                            "painList": [
                                "合同、招标文件人工审核耗时久",
                                "教培方案大量重复内容每次重写",
                                "员工Excel分析能力弱，简单报表也要找IT"
                            ],
                            "solutionSteps": [
                                {
                                    "num": 1,
                                    "title": "合同审核",
                                    "desc": "自动提取风险条款，审查30分钟缩至5分钟"
                                },
                                {
                                    "num": 2,
                                    "title": "招标解读",
                                    "desc": "自动提取评分标准、分析应标差距"
                                },
                                {
                                    "num": 3,
                                    "title": "教培方案",
                                    "desc": "基于历史模板快速生成定制方案"
                                },
                                {
                                    "num": 4,
                                    "title": "Excel提效",
                                    "desc": "自然语言生成透视表、图表、公式"
                                }
                            ],
                            "effectList": [
                                {
                                    "value": "+70%",
                                    "label": "Excel生产力"
                                },
                                {
                                    "value": "-83%",
                                    "label": "合同审查耗时"
                                },
                                {
                                    "value": "1天→1h",
                                    "label": "方案产出"
                                },
                                {
                                    "value": "全覆盖",
                                    "label": "4大办公场景"
                                }
                            ]
                        }
                    ]
                },
            ]
        }
    },
    created() {
        this.menus = this.industryList.map((x) => {
            return { name: x.name }
        })
    },
    activated() {
        var i = 0
        if (this.$route.query.index) {
            i = Number(this.$route.query.index)
        }
        this.getInfo(i)
    },
    mounted() {

    },
    methods: {
        getInfo(i) {
            this.mindex = i
            this.data = this.industryList[i]
        },
        setnum(i) {
            const arr = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
            return arr[i]
        }
    }
}
</script>
<style scoped>
.mindex {
    border-right: 3px solid #1e66d1;
    position: relative;
    right: -3px;
    color: #1e66d1;
    background: linear-gradient(to right, #e6e9ee, #fff);
}

.menu:hover {
    border-right: 3px solid #1e66d1;
    position: relative;
    right: -3px;
    color: #1e66d1;
    background: linear-gradient(to right, #e6e9ee, #fff);
}
</style>